import Box from '~/core/Box'
import Link from '~/core/Link'
import { isJapan, isUs } from '~/lib/appRegionConstants'
import { HELP_EMAIL } from '~/lib/emailAndUrls'
import { mailtoLink } from '~/lib/mailtoLink'
import { getenv } from '~/settings'
import styles from '../styles.css'

const PRIVACY = 'privacy'
const TERMS = 'terms'
const HELP = 'help'

export const PRIVACY_LINK = `${getenv('REGIONAL_CONFIGS')?.urls?.privacy}`
export const TERMS_LINK = `${getenv('REGIONAL_CONFIGS')?.urls?.terms}`

export const linkText = () => {
    if (isJapan()) {
        return 'Help'
    } else if (isUs()) {
        return 'Help Center'
    }
}

export const href = () => {
    if (isJapan()) {
        return `${mailtoLink(HELP_EMAIL, 'I need help!')}`
    } else if (isUs()) {
        return `${getenv('REGIONAL_CONFIGS')?.urls?.help_center}`
    }
}

export default function HyperLinks(props: { placement: string }) {
    const { placement } = props

    return (
        <Box className={styles.links}>
            {isUs() && (
                <Link
                    name={PRIVACY}
                    placement={placement}
                    href={PRIVACY_LINK}
                    target="_blank"
                >
                    Privacy Policy
                </Link>
            )}
            <Link
                name={TERMS}
                placement={placement}
                href={TERMS_LINK}
                target="_blank"
            >
                Terms of Service
            </Link>
            <Link
                name={HELP}
                placement={placement}
                href={href()}
                target="_blank"
            >
                {linkText()}
            </Link>
        </Box>
    )
}
